function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39.964,72.233c-4.365-.01-19.745-.347-34.381-4.289-3.303-1.04-5.55-3.853-5.582-6.997V15.696c.277-4.438,4.342-7.929,9.251-7.929.149,0,.3.003.45.01h60.63c.121-.007.269-.01.417-.01,4.909,0,8.972,3.461,9.25,7.88v45.291c-.031,3.147-2.261,5.96-5.55,6.996-14.663,3.95-30.046,4.289-34.411,4.298h-.074ZM9.262,12.163c-2.291,0-4.273,1.562-4.512,3.557l-.002,45.219c.062,1.305,1.071,2.461,2.51,2.891,6.493,2.118,23.701,4.004,32.707,4.004,9.229,0,26.159-1.845,32.761-3.998,1.447-.432,2.466-1.612,2.529-2.932V15.755c-.242-2.03-2.224-3.593-4.515-3.593-.118,0-.237.004-.355.012l-60.714.002c-.175-.01-.291-.014-.407-.014Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.31,58.573c-1.214,0-2.202-.987-2.202-2.2V18.695c0-1.213.987-2.2,2.2-2.2h57.383c1.213,0,2.201.987,2.201,2.2v37.633c0,1.212-.986,2.199-2.198,2.2l-57.384.046ZM13.509,54.171l52.982-.042V20.895H13.509v33.277Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M40,65.083c-1.213,0-2.201-.987-2.201-2.2s.987-2.2,2.201-2.2,2.2.987,2.2,2.2-.987,2.2-2.2,2.2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.421,65.083c-1.213,0-2.2-.987-2.2-2.2s.987-2.2,2.2-2.2,2.2.987,2.2,2.2-.987,2.2-2.2,2.2Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.58,65.083c-1.213,0-2.201-.987-2.201-2.2s.987-2.2,2.201-2.2,2.2.987,2.2,2.2-.987,2.2-2.2,2.2Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M40.001,50.513c-1.205-.006-2.31-.668-2.883-1.727l-5.593-10.362c-.695-1.22-1.075-2.608-1.1-4.019-.016-2.935,1.266-5.697,3.517-7.575,1.704-1.417,3.862-2.198,6.077-2.198.593,0,1.189.056,1.772.167,3.51.69,6.329,3.247,7.357,6.671.389,1.295.514,2.633.369,3.976-.139,1.109-.491,2.163-1.044,3.128l-5.582,10.222c-.575,1.055-1.679,1.713-2.881,1.716h-.009ZM39.989,28.083c-1.404,0-2.768.497-3.838,1.398-1.455,1.212-2.285,2.994-2.276,4.885.019.838.251,1.665.673,2.396l5.462,10.113,5.445-9.972c.333-.574.547-1.196.634-1.843.094-.876.01-1.748-.246-2.6-.653-2.189-2.45-3.825-4.69-4.269-.38-.071-.771-.107-1.163-.108h0Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M40.003,30.726c-1.919.003-3.482,1.566-3.485,3.485,0,1.918,1.563,3.48,3.483,3.48s3.482-1.562,3.482-3.482-1.561-3.482-3.48-3.483Z"
});

var SvgNavZone = function SvgNavZone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavZone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_zone.f52c00ea.svg";
export { ForwardRef as ReactComponent };